export function useIbanFormatter() {
  const sanitizeIban = (iban: string): string => {
    const sanitizedIban = iban.toUpperCase().replace(/[^A-Z0-9]/g, '');
    return sanitizedIban;
  };

  const formatIban = (iban: string): string => {
    return iban
      .replace(/(.{4})/g, '$1 ')
      .trim()
      .toUpperCase();
  };

  return { sanitizeIban, formatIban };
}
